module.exports = __webpack_public_path__ + "img/Dental3d_5.3e29e21d.png";